<template>
  <div class="business-license-container">
    <h1 class="main-title">营业执照模板</h1>

    <div class="img-wrapper">
      <img :src="licenseImg" class="license-img" alt="营业执照模板示例" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BusinessLicense",
  data() {
    return {
      licenseImg: require("@/assets/img/apply/cert/business_license_template.png")
    };
  }
};
</script>

<style lang="less" scoped>
.business-license-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 40px 60px;
  background-color: #ffffff;
  color: #262626;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  text-align: left;

  .main-title {
    margin: 0 0 28px 0;
    font-size: 26px;
    font-weight: 700;
    color: #1f1f1f;
    line-height: 1.3;
  }

  .img-wrapper {
    max-width: 930px;

    .license-img {
      display: block;
      width: 100%;
      max-width: 926px;
      height: auto;
      border-radius: 4px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
      border: 1px solid #f0f0f0;
    }
  }
}

@media only screen and (max-width: 768px) {
  .business-license-container {
    padding: 24px 16px;

    .main-title {
      font-size: 22px;
      margin-bottom: 20px;
    }

    .img-wrapper {
      .license-img {
        max-width: 100%;
      }
    }
  }
}
</style>
